module.exports = __webpack_public_path__ + "static/media/bathroomSink.685032eb.png";